// extracted by mini-css-extract-plugin
export var button = "_mj-0";
export var donut = "_mj-1";
export var donutFill = "_mj-3";
export var donutTrack = "_mj-2";